// extracted by css-extract-rspack-plugin
export default {"tag":"Z9tqNdyKK8d0WzdA","pageTitle":"bcsCiLlltQszU30N"};